import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IdleTimerProvider } from "react-idle-timer";
import { FOLDERPATHROUTER } from "./Constants/config";
import "./App.css";
import Layout from "./components/Layout";
import Login from "./Screen/Login";
import ForgotPassword from "./Screen/ForgotPassword";
import Dashboard from "./components/Dashboard";
import CandidatePersonalDetails from "./components/CandidatePersonalDetails";
import CandidateNationalID from "./components/CandidateNationalID";
import CandidateAddress from "./components/CandidateAddress";
import CandidateEducation from "./components/CandidateEducation";
import CandidateEmployment from "./components/CandidateEmployment";
import CandidateCreditExperianHistory from "./components/CandidateCreditHistory";
import CandidateProfessionalReference from "./components/CandidateProfessionalReference";
import CandidatePersonalReference from "./components/CandidatePersonalReference";
import CandidateOtherDetails from "./components/CandidateOtherDetails";
import CandidateOnboardingDetails from "./components/CandidateOnboardingDetails";
import CandidatePreviewFormData from "./components/CandidatePreviewFormData";
import CandidateThankYou from "./components/CandidateThankYou";
import ClientThankYou from "./components/ClientThankYou";
import CandidateTab from "./components/CandidateTab";
import InsuffContainer from "./components/InsuffContainer";
import CandidateLicense from "./components/CandidateLicense";
import CandidateDrugCheck from "./components/CandidateDrugCheck";
import CandidateCreditCibilHistory from "./components/CandidateCreditCibilHistory";
import CandidateOtherDetailsTwo from "./components/CandidateOtherDetailsTwo";
import CandidateWorkEligibility from "./components/CandidateWorkEligibility";
import CandidateScotlandDiscloser from "./components/CandidateScotlandDiscloser";
import CandidateDoctorRegistration from "./components/CandidateDoctorRegistration";
import CandidateProfessionalLicenceCheck from "./components/CandidateProfessionalLicenceCheck";
import CandidateAadhaarVerification from "./components/CandidateAadhaarVerification";
import CandidateIndianPoliceRecord from "./components/CandidateIndianPoliceRecord";
import CandidateBusinessAddressDetails from "./components/CandidateBusinessAddressDetails";
import CandidateWorkEligibility1 from "./components/CandidateWorkEligibility1";
import DigitalAddressVerification from "./components/DigitalAddressVerification";
import EmploymentGaps from "./components/EmploymentGaps";
import Authorization from "./components/Authorization";
import CandidatePv from "./components/CandidatePv";
import LoginHelper from "./components/LoginHelper";
import EducationDigilocker from "./Actions/Education-upload-via-digilocker";
import ProtectedRoutes from "./components/ProtectedRoutes";
import ErrorPage404 from "./Screen/errorPage404";
// import DuplicateInDBModal from "./components/DuplicateInDB";
//import "./assets/fontawesome-free-5.15.1/css/all.min.css";
import "./assets/fontawesome-free-6.2.0-web/css/all.min.css";
import MainForm from "./components/LicenseForm/MainForm";
import CandidatePersonalDetailByClient from "./components/CandidatePersonalDetailByClient";
import DigiLockerCallback from "./components/EducationForm/digiLockerCallback";
import InstaIDMain from "./UI_Design/InstantNIDWithOCR/InstaIDMain";
import NationalIDNew from "./components/NationalIDTab/NationalIDNew";
import IBVerification from "./components/BankVisual/IBVerification";
import MainFormPageBank from "./components/BankVisual/MainFormPageBank";
import MainFormPageVisual from "./components/BankVisual/MainFormPageVisual";
import EmploymentVerification from "./components/InstantUANEmploymentClosure/EmploymentVerification";
import MainFormPageInstantBank from "./components/BankVisual/MainFormPageInstantBank";
import ClientThankYouWithPay from "./components/ClientThankYouWithPay";
import Payment from "./components/Payment";
import PaymentSuccessful from "./components/PaymentScreen/PaymentSuccessful";
import Tabs from "./UI_Design/tabs/Tabs";
import SingleTabsMain from "./UI_Design/SingleTab/SingleTabsMain";
import InsuffFulfilThankyouPage from "./components/InsufffulfilThankyouPage";
import ArnAuthorization from "./components/ArnAuthorization";
import ArnThankyou from "./components/ArnThankyou";
import MainFormDigi from "./components/DiyIcvDigilockerSingleEducation/MainFormDigi";
import MainFormDigiLocker from "./components/DiyDigilockerNonIBridge/MainFormDigiLocker";
import UploadedDocs from "./components/DiyDigilockerNonIBridge/UploadedDocs";
import MainFormCreditHistory from "./components/CreditHistory/MainFormCreditHistory";
import UploadDIgiDocs from "./components/EducationForm/UploadDIgiDocs";
import { getLogout } from "./Actions/logoutAction";
import NewEmploymentForm from "./components/NewEmploymentForm/NewEmploymentForm";
import EmploymentContainer from "./components/CandidateEmploymentv2/EmploymentContainer";
// import RenderingDynamicModal from "./UI_Design/DynamicModal/RenderingDynamicModal";
// import EmploymentGapsForm from "./components/NewEmploymentForm/EmploymentGapsForm";
import MainFormOnbording from "./components/OnbordingForm/MainFormOnbording";
import OnbordingDetailsInstaform from "./components/OnbordingForm/OnbordingDetailsInstaform";
import CourtRecordCheckDeclaration from "./components/CourtRecordCheckDeclaration/CourtRecordCheckDeclaration";
import Form16 from "./components/Form16/form16";
import EmploymentViaUANContainer from "./components/CandidateEmploymentViaUAN/EmploymentViaUANContainer";
import EAadhaarDigiLockerCallback from "./components/AadhaarVerification/eAadhaarDigiCallback";
function App() {
  const userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
  const loginLocalData = JSON.parse(localStorage.getItem("autoLogin"));
  const storeData = useSelector((state) => state.user);
  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData} = autoLoginStore;
  const { userData } = storeData;
  const [updatedUserData, setUpdatedUserData] = useState({});
  const [autoLoginLocalData, setAutoLoginLocalData] = useState({});
  const dispatch = useDispatch();

  const onIdle = () => {
    if (localStorage.getItem("userVerificationCandidate")) {
      dispatch(getLogout());
    } 
  };

  useEffect(() => {
  setUpdatedUserData(userData)
  },[userData])

  useEffect(() => {
    if(autoLoginData?.data){
      setAutoLoginLocalData(autoLoginData?.data)
    }
  },[autoLoginData])


  return (
    <IdleTimerProvider
      timeout={1000 * 30 * 60}
      onIdle={onIdle}
    >
          <BrowserRouter basename={FOLDERPATHROUTER + "/candidate-flow"}>
      <Routes>
        <Route 
          exact
          path="/digiLockerCallback"
          element={<DigiLockerCallback />}
        />
        <Route 
          exact
          path="/aadharDigiLockerCallback"
          element={<EAadhaarDigiLockerCallback />}
        />
        <Route path="/" element={<Layout />}>
          <Route exact path="/" element={<Login />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/ArnAuthorization" element={<ArnAuthorization />} />
          <Route exact path="/ArnThankyou" element={<ArnThankyou />} />

          <Route
            exact
            path="/candidate-form/indian-police-record"
            element={<CandidateIndianPoliceRecord />}
          />
          <Route
            exact
            path="/candidate-form/authorization"
            element={<Authorization />}
          />

          <Route exact path="/autoReactLogin" element={<LoginHelper />} />
          {/* protected routes start*/}

          <Route
            exact
            path="/case-initiation/check-detail/:caseId/profile"
            element={<CandidatePersonalDetails />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:caseId/candidate-profile"
            element={<CandidatePersonalDetailByClient />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:reference/3"
            element={<CandidateEducation />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:reference/3/:activeTab"
            element={<CandidateEducation />}
          />
          {
            !!(userLocalData?.is_new_emp_form || updatedUserData?.is_new_emp_form || autoLoginLocalData?.is_new_emp_form) && 
            <Route
            exact
            path="/case-initiation/check-detail/:reference/4/*"
            element={<EmploymentContainer />}
          />
          }
          {!(userLocalData?.is_new_emp_form || updatedUserData?.is_new_emp_form || autoLoginLocalData?.is_new_emp_form) && 
          <Route
          exact
          path="/case-initiation/check-detail/:reference/4"
          element={<CandidateEmployment/>}
        />
          }
          {!(userLocalData?.is_new_emp_form || updatedUserData?.is_new_emp_form || autoLoginLocalData?.is_new_emp_form) && 
          <Route
          exact
          path="/case-initiation/check-detail/:reference/4/:activeTab"
          element={<CandidateEmployment/>}
        />
          }
          <Route
            exact
            path="/case-initiation/check-detail/:reference/10"
            element={<CandidateDrugCheck />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:reference/10/:activeTab"
            element={<CandidateDrugCheck />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:reference/12"
            element={<CandidateLicense />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:reference/12/:activeTab"
            element={<CandidateLicense />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:caseId/nid"
            // element={<CandidateNationalID />}
            element={<NationalIDNew />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:reference/2"
            element={<CandidateAddress />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:reference/2/:activeTab"
            element={<CandidateAddress />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:reference/7"
            element={<CandidatePv />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:reference/5"
            element={<CandidateProfessionalReference />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:reference/5/:activeTab"
            element={<CandidateProfessionalReference />}
          />

          <Route
            exact
            path="/case-initiation/profile-preview/:caseId"
            element={<CandidatePreviewFormData />}
          />
          <Route
            exact
            path="/case-initiation/profile-preview/:reference"
            element={<CandidatePreviewFormData />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:caseId/9"
            element={<CandidateOtherDetailsTwo />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:caseId/6/:activeTab"
            element={<CandidatePersonalReference />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:caseId/6"
            element={<CandidatePersonalReference />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:caseId/13"
            element={<CandidateDoctorRegistration />}
          />
          <Route
            exact
            path="/case-initiation/Educationdigilocker"
            element={<EducationDigilocker />}
          />

          <Route
            exact
            path="/candidate-form/other-details"
            element={<CandidateOtherDetails />}
          />
          <Route
            exact
            path="/candidate-form/thank-you"
            element={<CandidateThankYou />}
          />
          <Route
            exact
            path="/candidate-form/client-thank-you"
            element={<ClientThankYou />}
          />
           <Route
            exact
            path="/candidate-form/insuff-thank-you"
            element={<InsuffFulfilThankyouPage />}
          />
           <Route   
            exact
            path="/candidate-form/client-thank-you-with-pay"
            element={<ClientThankYouWithPay />}
          />
           <Route   
            exact
            path="/candidate-form/payment"
            element={<Payment />}
          />
          <Route   
            exact
            path="/candidate-form/payment-completed"
            element={<PaymentSuccessful />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:caseId/8/"
            element={<CandidateCreditExperianHistory />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:caseId/8/cibil"
            element={<CandidateCreditCibilHistory />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:reference/15"
            element={<CandidateScotlandDiscloser />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:reference/20"
            element={<MainFormPageBank />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:reference/21"
            element={<MainFormPageVisual />} 
          />
           {/* <Route
            exact
            path="/case-initiation/check-detail/:reference/20"
            element={<MainFormPageInstantBank />} 
          /> */}
          <Route
            exact
            path="/case-initiation/check-detail/:reference/22"
            element={<EmploymentVerification />}
          />
          <Route
            exact
            path="/case-initiation/check-detail/:reference/eaadhar"
            element={<CandidateAadhaarVerification />}
          />
          {/* <Route

<Route
              exact
              path="/case-initiation/check-detail/:reference/7"
              element={<CandidatePv />}
            />
          {/* <Route



           */}

          <Route
            exact
            path="/case-initiation/check-detail/:reference/18"
            element={<CandidateBusinessAddressDetails />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:reference/18/:activeTab"
            element={<CandidateBusinessAddressDetails />}
          />

          <Route
            exact
            path="/case-initiation/check-detail/:reference/14"
            element={<CandidateWorkEligibility />}
          />
          {!!(userData?.redirect_insuff || userLocalData?.redirect_insuff) ? (
            <Route
              element={
                <ProtectedRoutes
                  permission={
                    !!(
                      userData?.redirect_insuff ||
                      userLocalData?.redirect_insuff
                    )
                  }
                />
              }
            >
              <Route
                exact
                path="/candidate-form/insuff"
                element={<InsuffContainer />}
              />
            </Route>
          ) : (
            <Route
              element={
                <ProtectedRoutes
                  permission={
                    !(
                      userData?.redirect_insuff ||
                      userLocalData?.redirect_insuff
                    )
                  }
                />
              }
            >
              <Route exact path="/dashboard" element={<Dashboard />} />

              <Route exact path="/candidate-form" element={<CandidateTab />} />
              {/* <Route exact path="/candidate-form/personal-details" element={<CandidatePersonalDetails />} /> */}
              {/* <Route exact path="/candidate-form/personal-details" element={<CandidatePersonalDetails />} /> */}

              <Route
                exact
                path="/candidate-form/credit-history"
                element={<CandidateCreditExperianHistory />}
              />
              <Route
                exact
                path="/candidate-form/professional-reference"
                element={<CandidateProfessionalReference />}
              />
              <Route
                exact
                path="/candidate-form/authorization"
                element={<Authorization />}
              />
              {/* <Route
            exact
            path="/candidate-form/duplicity"
            element={<DuplicateInDBModal />}
          /> */}
              <Route
                exact
                path="/candidate-form/personal-reference"
                element={<CandidatePersonalReference />}
              />
              <Route
                exact
                path="/candidate-form/other-details"
                element={<CandidateOtherDetails />}
              />
              <Route
                exact
                path="/candidate-form/onboarding-details"
                element={<CandidateOnboardingDetails />}
              />
              <Route
                exact
                path="/candidate-form/preview-form-data"
                element={<CandidatePreviewFormData />}
              />
              <Route
                exact
                path="/candidate-form/thank-you"
                element={<CandidateThankYou />}
              />
              <Route
                exact
                path="/candidate-form/other-details-2"
                element={<CandidateOtherDetailsTwo />}
              />
              <Route
                exact
                path="/candidate-form/work-eligibility"
                element={<CandidateWorkEligibility />}
              />

              <Route
                exact
                path="/candidate-form/scotland-disclosure"
                element={<CandidateScotlandDiscloser />}
              />

              <Route
                exact
                path="/candidate-form/professional-licence-check"
                element={<CandidateProfessionalLicenceCheck />}
              />
              <Route
                exact
                path="/case-initiation/check-detail/:reference/30"
                element={<DigitalAddressVerification />}
              />
              <Route
                exact
                path="/candidate-form/emp-gaps"
                element={<EmploymentGaps />}
              />

              <Route
                exact
                // path="/CourtRecordCheckDeclaration"
                path="/case-initiation/check-detail/:reference/50"
                element={ <CourtRecordCheckDeclaration /> }
              />

              <Route
                exact
                // path="/CourtRecordCheckDeclaration"
                path="/case-initiation/check-detail/:reference/23"
                element={ <Form16 /> }
              />

              {/* <Route
                exact
                path="/OnbordingDetailsInstaform*"
                // element={<MainFormOnbording />}
                element={<OnbordingDetailsInstaform />}
              /> */}
              <Route
                exact
                // path="/OnbordingDetailsInstaform*"
              path="/case-initiation/check-detail/:reference/11/*"
                element={<OnbordingDetailsInstaform />}
              />

            {/* <Route exact path="/test" element={<Tabs />} /> */}
            {/* <Route exact path="/RenderingDynamicModal" element={<RenderingDynamicModal />} /> */}
            {/* <Route exact path="/EmploymentGapsForm" element={<EmploymentGapsForm />} /> */}
            <Route exact path="/NewEmploymentForm/*" element={<NewEmploymentForm />} />

            <Route exact path="/test" element={<Tabs />} />
            <Route exact path="/SingleTabsMain" element={<SingleTabsMain />} />
            <Route exact path="/diydigi" element={<MainFormDigi />} />
            <Route exact path="/diydigiui" element={<MainFormDigiLocker />} />
            <Route exact path="/diydigiupload" element={<UploadedDocs />} />
            <Route exact path="/UploadDIgiDocs" element={<UploadDIgiDocs />} />

              {/* calling researcher routes */}
              {/* {ResearcherRoute}
						{GeneralRoute} */}
                
            <Route exact path="/ch" element={<MainFormCreditHistory />} />

              {/* common routes start*/}
              {/* <Route exact path="/dashboard" element={<Dashboard />} /> */}
              {/* common routes end*/}
              {
                // !!(userLocalData?.is_new_emp_form || updatedUserData?.is_new_emp_form || autoLoginLocalData?.is_new_emp_form) && 
                <Route
                exact
                path="/case-initiation/check-detail/:reference/24/*"
                element={<EmploymentViaUANContainer />}
              />
              }
            </Route>
          )}

          {/* protected routes end*/}
        </Route>
        <Route path="*" element={<ErrorPage404 />} />
      </Routes>
    </BrowserRouter>
    </IdleTimerProvider>
  );
}

export default App;
